var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabletWithOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 918,
    height: 1112,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 923,
    width: 918,
    height: 1112
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2219,
    y1: 1886,
    x2: 2219,
    y2: 1037,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080808"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1760 -923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2170 1954.5C2170 1927.16 2192.16 1905 2219.5 1905 2246.84 1905 2269 1927.16 2269 1954.5 2269 1981.84 2246.84 2004 2219.5 2004 2192.16 2004 2170 1981.84 2170 1954.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.52 2030C1819.48 2030 1819.48 2030 1819.48 2030 1787.7 2030 1765 2006.25 1765 1973 1765 985 1765 985 1765 985 1765 951.75 1787.7 928 1819.48 928 2618.52 928 2618.52 928 2618.52 928 2650.3 928 2673 951.75 2673 985 2673 1973 2673 1973 2673 1973 2673 2006.25 2650.3 2030 2618.52 2030M2219 1992C2237.16 1992 2255.32 1973 2255.32 1954 2255.32 1935 2237.16 1916 2219 1916 2200.84 1916 2182.68 1935 2182.68 1954 2182.68 1973 2200.84 1992 2219 1992M2564.04 1042C1873.96 1042 1873.96 1042 1873.96 1042 1873.96 1878 1873.96 1878 1873.96 1878 2564.04 1878 2564.04 1878 2564.04 1878L2564.04 1042Z",
    stroke: "#FFFFFF",
    strokeWidth: 10.3125,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#C00000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1862,
    y: 1037,
    width: 714,
    height: 849,
    fill: "url(#fill1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletWithOutline);
export default __webpack_public_path__ + "static/media/tabletWithOutline.8b62a4d85bbaf5d34eb2985ec0eef7c6.svg";
export { ForwardRef as ReactComponent };